import searchResults from "./search-results.json";
import searchMonthlyResults from "./monthly-search-results.json";
import emptySearchMonthlyResults from "./monthly-search-results-empty.json";
import searchDailyResults from "./daily-search-results.json";
import heldResortResults from "./held-resorts.json";
import contractUsages from "./contract-usages.json";
import contractTooltips from "./contract-tooltips.json";
import ownerContracts from "./owner-contracts.json";
import reservationResult from "./reservation-result.json";
import pointsCalculator from "./enhanced-points-calculator.json"
import searchDateRangeResults from "./date-range-search-results.json";
import createWaitlistResponse from "./create-waitlist-response.json";
import cancelReservationDetailRequest from "./cancel-reservation-request.json"
import "./axiosInterceptors";

import {Guid} from "guid-typescript";
import log, {
    JAHIA_ROOMS_API_URL,
    API_CALL_TIMEOUT,
    EXPERIENCE_API_URL,
    RESERVATION_API_URL,
    AUTO_ADJUST_API_URL,
    AYP_URL,
    WAITLISTS_AYP_URL,
    WAITLIST_API_URL,
    RESERVATION_BOOK_API_URL,
    OWNER_PROFILE_API_URL,
    OWNER_PROPERTIES_API_URL,
    TERMS_CONDITION_URL,
    ADS_API,
    RESERVATION_DETAIL_API_URL,
    RESERVATION_LIST_API_URL,
    COUNTRY_LIST_API_URL,
    POINTS_CALCULATOR_API_URL,
    TRANSACTION_LIST_API_URL,
    OWNER_INFO_API_URL,
    HOPPER_AVAIL_INFO_API_URL,
    CHECK_ELIGIBILITY_URL,
    WAITLISTS_CREATE_API_URL,
    WAITLIST_SUMMARY_REVIEW_URL,
    TRANSFER_POINTS_CONTRACTS_URL,
    GUEST_TERMS_API_URL,
    GUEST_PROFIEL_URL,
    RESERVATION_DETAIL_API_URL_WEEKS,
} from "../cfg";

import timeoutPromise, {COGNITO_SSO_TOKEN, handleError, OWNER_NUMBER, SYSTEM_INTEGRATION_MODE, X_CORRELATION_ID} from "./service.utils";
import axios, {AxiosResponse} from "axios";
import SearchCriteria from "Interfaces/SearchCriteriaInterface";
import { HoldRequestData } from "Interfaces/HoldRequestData";
import { WaitlistData } from "Interfaces/WaitlistData"
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";
import searchCriteria from "./search-criteria.json"
import resSummary from "./res-summary.json"
import bookingResult from "./booking-result.json"
import resWaitlistSummary from "./res-waitlist-summary.json"
import getResortOverviewResult from "./get-resort-overview.json"
import getReservationsResult from "./get-reservations-result.json"
import getCountriesJSON from "./get-countries-result.json"
import getTransferContracts from "./get-transfer-points-contracts.json";
import submitTrasnferPoints from "./submit-transfer-points.json";
import Results from "Interfaces/ResultsInterface";
import FormData from "Interfaces/FormDataInterface";
import moment from "moment";
import ResortResult, { DailyAvailability, WaitlistRooms } from "Interfaces/ResortResultInterface";
import {AYPResult, WaitlistAYPResult, ContractUsage, WaitlistSummaryResponse} from "Interfaces/AYPResultInterface";
import ContractToolTip from "Interfaces/ContractToolTipInterface";
import { OwnerContract } from "Interfaces/OwnerInterface";
import { BookResortParams, BookResortResult, ReservationResult } from "Interfaces/BookResort";
import { GetCountriesResult, GetReservationActivity, GetReservationsResult, ReservationType } from "Interfaces/GetReservations";
import CalculatorFormData from "Interfaces/CalculatorFormDataInterface";
import { GetAdsResponse } from "Interfaces/AdsInterface";
import { ResortPointInterface } from "Interfaces/ResortPointInterface";
import { TransactionHistoryResult } from "Interfaces/Transactions";
import getTransactionsResult from "./transaction-history-by-transaction.json"
import getGuestTerms from "./guestTerms-result.json";
import {HopperAvailabiltyInfo, OwnerInfoRecord} from "../Interfaces/OwnerInfo";
import ContractType from "Interfaces/AdvanceSearchInterface";
import { TermConditionRecord } from "../Interfaces/Termcondition";
import { AnySoaRecord } from "dns";
import { GuestTerms } from "Components/Pages/ArrivingGuestInfo/types";
import { GuestProfileRequest, GuestProfileResponse } from "Components/Pages/ArrivingGuestInfo/types"
import { TransferPointRequest, TransferPointResponse } from "Components/Pages/TransferPoints/types";

export interface SearchResortsRequest {
    accessibility: string[];
    segments: string[];
    contracts: string[];
    resorts: string[];
    flexibleSearch: boolean;
    numGuests: number;
    numNights: number;
    //hearing: boolean;
    startDate: string;
    sortBy: string;
    centralRoomTypeCode?: any;
    viewCode?: any;
    ownerBenefitLevel: string;
    searchType: string;
}

export interface PlaceHoldRequest {
    resortCode: string,
    checkIn: string|Date,
    marshaRateCode: string,
    numOfGuests: number;
    numOfNights: number;
    accessibility: string[];
    hearingaccessible: boolean;
    roomPoolCode: string[];
    dailyresults?: DailyAvailability;
    contracts?: any;
};

export interface CreateWaitlistRequest {
    // ownerId: any;
    totalPointsToHold: number;
    checkInRangeStart: string | Date;
    checkInRangeEnd: string | Date;
    propertyCode: string;
    numberOfGuests: any;
    numberOfNights: any;
    accessibility: number[];
    maxPpe: number;
    checkInSunday: boolean;
    checkInMonday: boolean;
    checkInTuesday: boolean;
    checkInWednesday: boolean;
    checkInThursday: boolean;
    checkInFriday: boolean;
    checkInSaturday: boolean;
    sessionId: string;
    priority: number;
    waitlistRooms: WaitlistRooms[];
    contracts: any;
};

class ReservationService {
    static SEARCH_CRITERIA_SESSION_ID = "SC_SessionId";
    static SEGMENTS = "Segments";
    static BENEFIT_LEVEL = "BenefitLevel";
    static OPS_FORM_SESSION_KEY = "OPS_Form";
    static SELECT_AVAILABILITY_STATE = "SA_State";
    static APPLIED_POINTS = "AppliedPoints";
    static CONTRACT_TOOL_TIPS = "ContractToolTips";
    static SELECTED_PREFERENCES = "SelectedPreferences";
    static BOOKED_RESERVATION = "BookedReservation";
    static USAGE_REQUIRED_BY_DAY = "UsageRequiredByDay";
    static SELECTED_LANGUAGE = "Selected-Lang";
    static DEFAULT_SEARCH_RESULT = "default_search_result";
    static ALTERNATE_SEARCH_RESORT="isAlternateSearchAvailable";

    private globalSessionId: string = "";

    private getSessionIdForRequest() {
        if (!this.globalSessionId) {
            const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
            if (savedSID && savedSID !== 'null' && savedSID !== 'undefined') {
                this.globalSessionId = savedSID;
            } else {
                this.globalSessionId = Guid.create().toString();
                sessionStorage.write(ReservationService.SEARCH_CRITERIA_SESSION_ID, this.globalSessionId);
            }
        }
        return this.globalSessionId;
    }

    baseUrl: string = "";

    clearTemporarilyHeldReservationsFake(): Promise<any> {
        return new Promise<any | void | void>((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, 1500);
        });
    }
    clearTemporarilyHeldReservations(): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = RESERVATION_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.clearTemporarilyHeldReservationsFake();
        }

        const savedSID = '' //sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        return timeoutPromise(to, "deleting all held reservations",
            axios.delete(apiUrl,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': savedSID,
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`response body ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl)));
    }

    searchFake(): Promise<Results> {
        return new Promise<Results>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(searchResults);
                let sr: Results = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    search(query: FormData, segments: string[]): Promise<Results> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        // Prevent API call if cognitoSsoToken is not available
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const startDate = query.startDate;
        const formattedStartDate = moment(startDate).format('YYYYMMDD');
        if (!moment(formattedStartDate, "YYYYMMDD", true).isValid()) {
            return Promise.reject(new Error("To continue this search, please enter the check-in date you would like to reserve."));
        }
        const apiUrl: string = EXPERIENCE_API_URL;
        console.log(apiUrl)
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        //TODO: Siva => had to convert TRUE to %TRUE to force mock data, need to investigate why TRUE is not working, lower priority
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.searchFake();
        }

        log.debug(`Calling search API: ${apiUrl}`);
        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        const accessibility= query.accessibility ? [query.accessibility] : [];
        if (query.hearing){
            accessibility.push('B4');
        }

        let req: SearchResortsRequest = {
            accessibility,
            segments: segments ? segments : JSON.parse(sessionStorage.read(ReservationService.SEGMENTS)),
            contracts: query.contracts ? query.contracts : [],
            resorts: query.resorts ? query.resorts : [],
            flexibleSearch: query.flexibleSearch,
            numGuests: query.numGuests,
            numNights: query.numNights,
            startDate: formattedStartDate,
            sortBy: query.sortBy,
            searchType: 'DEFAULT',
            ownerBenefitLevel: sessionStorage.read(ReservationService.BENEFIT_LEVEL)
        };
        log.debug(`request body ${JSON.stringify(req)}`);

        const sessionId = this.getSessionIdForRequest();
        return timeoutPromise(to, "loading search results",
            axios.post(apiUrl, req,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': sessionId,
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`response body ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<Results>;
    }
    calculateFake(): Promise<ResortPointInterface[]> {
        return new Promise<ResortPointInterface[]>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(pointsCalculator);
                let sr: ResortPointInterface[] = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    calculate(query: CalculatorFormData): Promise<ResortPointInterface[]> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const startDate = query.startDate;
        const formattedStartDate = moment(startDate).format('YYYYMMDD');
        if (!moment(formattedStartDate, "YYYYMMDD", true).isValid()) {
            return Promise.reject(new Error("To continue this search, please enter the check-in date you would like to reserve."));
        }
        const apiUrl: string = POINTS_CALCULATOR_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.calculateFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        let req: CalculatorFormData = {
            resorts: query.resorts ? query.resorts : [],
            numGuests: query.numGuests,
            numNights: query.numNights,
            startDate: formattedStartDate,
            ownerBenefitLevel: sessionStorage.read(ReservationService.BENEFIT_LEVEL),
            segments: JSON.parse(sessionStorage.read(ReservationService.SEGMENTS)),
        };

        return timeoutPromise(to, "loading search results",
            axios.post(apiUrl, req,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': savedSID,
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<ResortPointInterface[]>) => {
                        log.debug(`response body ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<ResortPointInterface[]>;
    }

    getExistingWaitlist(): Promise<any> {
        const apiUrl: string = EXPERIENCE_API_URL;
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        return timeoutPromise(to, "get existing waitlist for check-in dates range",
            axios.post(
                apiUrl, {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': this.getSessionIdForRequest(),
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                }
            )
            .then((resp: AxiosResponse<any>) => {
                    log.debug(`response body ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<Results>;
    }


    getSearchCriteriaFake(): Promise<SearchCriteria> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let scStr: string = JSON.stringify(searchCriteria);
                let sc: SearchCriteria = JSON.parse(scStr);
                resolve(sc);
            }, 1500);
        });
    }

    getSearchCriteria(): Promise<SearchCriteria> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        // Prevent API call if cognitoSsoToken is not available
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = EXPERIENCE_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getSearchCriteriaFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        this.globalSessionId = Guid.create().toString();
        sessionStorage.write(ReservationService.SEARCH_CRITERIA_SESSION_ID, this.globalSessionId);
        this.globalSessionId = "";
        const sessionId = this.getSessionIdForRequest();

        return timeoutPromise(to, "loading data for search criteria",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': sessionId,
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<SearchCriteria>) => {
                        const currentSID = resp.data.sessionId;
                        if (!savedSID || savedSID !== currentSID) {
                            sessionStorage.write(ReservationService.SEARCH_CRITERIA_SESSION_ID, currentSID);
                        }
                        if (currentSID) {
                            this.globalSessionId = currentSID;
                        }

                        if (resp.data.segments && resp.data.segments.length > 0) {
                            sessionStorage.write(ReservationService.SEGMENTS, JSON.stringify(resp.data.segments));
                        } else {
                            sessionStorage.write(ReservationService.SEGMENTS, "[]");
                        }
                        if (resp.data.ownerBenefitLevel) {
                            sessionStorage.write(ReservationService.BENEFIT_LEVEL, resp.data.ownerBenefitLevel);
                        } else {
                            sessionStorage.write(ReservationService.BENEFIT_LEVEL, "");
                        }

                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<SearchCriteria>;
    }

    getUserContracts(reservedInventoryID: number): Promise<AYPResult> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const aypUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/owner/apply-your-points/${reservedInventoryID}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getFakeUserContracts();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for Apply Your Points",
            axios.get(aypUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<AYPResult>) => {
                        log.debug(`Apply Your Points - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, aypUrl))) as Promise<AYPResult>;
    }

    getFakeUserContracts(): Promise<AYPResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let aypString: string = JSON.stringify(contractUsages);
                let aypUsages: AYPResult = JSON.parse(aypString);
                resolve(aypUsages);
            }, 1500);
        });
    }

    getWaitlistsUserContracts(waitlistId: any): Promise<WaitlistAYPResult> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const aypUrl: string = `${WAITLISTS_AYP_URL}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            // return this.getFakeWaitlistsUserContracts();
        }


        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for Apply Your Points",
            axios.post(aypUrl, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<WaitlistAYPResult>) => {
                        return resp.data
                    }
                )
                .catch((error: any) => {
                    handleError(error, aypUrl)
                }
                )) as Promise<WaitlistAYPResult>;
    }

    getFakeWaitlistsUserContracts(): Promise<AYPResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let aypString: string = JSON.stringify(contractUsages);
                let aypUsages: AYPResult = JSON.parse(aypString);
                resolve(aypUsages);
            }, 1500);
        });
    }

    getOwnerContractsFake(contractIds: string[]): Promise<OwnerContract[]> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                // current username = irene.tan
                const contractsString: string = JSON.stringify(ownerContracts);
                const oContracts: OwnerContract[] = JSON.parse(contractsString);
                resolve(oContracts);
            }, 1500);
        });
    }

    getOwnerContracts(contractIds: any): Promise<OwnerContract[]> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = OWNER_PROFILE_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getOwnerContractsFake(contractIds);
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        // convert contractIds to this format: {"contractIds": ["11140","15364","26223"]}
        let contractIdsObj = { "contractIds": Array.from(contractIds)  }
        log.debug("Owner Contracts contractIdsObj stringify", `${JSON.stringify(contractIdsObj)}`);


        return timeoutPromise(to, "loading data for Owner Contracts",
            axios.post(apiUrl, contractIdsObj, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
            .then((resp: AxiosResponse<ResortResult[]>) => {
                    log.debug(`Owner Contracts - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<OwnerContract[]>;
    }

    searchFakeMonthlyAvailability(query: FormData): Promise<Results> {
        return new Promise<Results>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(searchMonthlyResults);
                let sr: Results = JSON.parse(srStr);

                sr.monthlyresults = sr.monthlyresults.filter(result => moment(result.date).toDate().getMonth() === moment(query.startDate).toDate().getMonth())
                resolve(sr);
            }, 1500);
        });
    }

    searchFakeMonthlyAvailabilityEmpty(query: FormData): Promise<Results> {
        return new Promise<Results>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(emptySearchMonthlyResults);
                let sr: Results = JSON.parse(srStr);

                sr.monthlyresults = sr.monthlyresults.filter(result => moment(result.date).toDate().getMonth() === moment(query.startDate).toDate().getMonth())
                resolve(sr);
            }, 1500);
        });
    }

    searchMonthlyAvailability(resortCode: string, query: FormData, date: string | undefined, segments: string[]): Promise<Results> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const startDate = query.startDate;
        const formattedStartDate = moment(startDate).format('YYYYMMDD');
        if (!moment(formattedStartDate, "YYYYMMDD", true).isValid()) {
            return Promise.reject(new Error("To continue this search, please enter the check-in date you would like to reserve"));
        }
        const apiUrl: string = EXPERIENCE_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') { //TODO: check 
            return this.searchFakeMonthlyAvailability(query);
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        const accessibility= query.accessibility ? [query.accessibility] : [];

        if (query.hearing){
            accessibility.push('B4');
        }
        let req: SearchResortsRequest = {
            accessibility,
            segments: segments ? segments : JSON.parse(sessionStorage.read(ReservationService.SEGMENTS)),
            contracts: query.contracts ? query.contracts : [],
            resorts: [resortCode],
            flexibleSearch: true, //query.flexibleSearch,
            numGuests: query.numGuests,
            numNights: query.numNights,
            startDate: formattedStartDate,
            sortBy: '', //query.sortBy,
            searchType: 'MONTHLY',
            centralRoomTypeCode: query.centralRoomTypeCode,
            viewCode: query.viewCode,
            ownerBenefitLevel: sessionStorage.read(ReservationService.BENEFIT_LEVEL)
        };

        const sessionId = this.getSessionIdForRequest();
        return timeoutPromise(to, "loading monthly availability search results",
        axios.post(apiUrl, req,
            {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': sessionId,
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`monthly availability search - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<Results>;
    }


    searchFakeDailyAvailability(): Promise<Results> {
        return new Promise<Results>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(searchDailyResults);
                let sr: Results = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    searchDailyAvailability(resortCode: string, selectedDate: string, query: FormData, segments: string[]): Promise<Results> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = EXPERIENCE_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.searchFakeDailyAvailability();
        }

        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        const accessibility= query.accessibility ? [query.accessibility] : [];
        
        if (query.hearing){
            accessibility.push('B4');
        }

        let req: SearchResortsRequest = {
            accessibility,
            segments: segments ? segments : JSON.parse(sessionStorage.read(ReservationService.SEGMENTS)),
            contracts: query.contracts ? query.contracts : [],
            resorts: [resortCode],
            flexibleSearch: false, //query.flexibleSearch,
            numGuests: query.numGuests,
            numNights: query.numNights,
            startDate: moment(selectedDate).format('YYYYMMDD'),
            sortBy: '',
            searchType: 'DAILY',
            centralRoomTypeCode: query.centralRoomTypeCode,
            viewCode: query.viewCode,
            ownerBenefitLevel: sessionStorage.read(ReservationService.BENEFIT_LEVEL)
        };

        const sessionId = this.getSessionIdForRequest();
        return timeoutPromise(to, "loading daily availability search results",
            axios.post(apiUrl, req,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': sessionId,
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`daily availability search - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<Results>;
    }

    searchFakeDateRangeAvailability(): Promise<Results> {
        return new Promise<Results>((resolve, rejects) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(searchDateRangeResults);
                let sr: Results = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    searchDateRangeAvailability(resortCode: string, selectedDate: string, query: FormData) :Promise<Results> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = EXPERIENCE_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.searchFakeDateRangeAvailability();
        }

        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        let req: SearchResortsRequest = {
            accessibility: query.accessibility ? [query.accessibility] : [],
            segments: JSON.parse(sessionStorage.read(ReservationService.SEGMENTS)),
            contracts: query.contracts ? query.contracts : [],
            resorts: [resortCode],
            flexibleSearch: false, //query.flexibleSearch,
            numGuests: query.numGuests,
            numNights: query.numNights,
            startDate: moment(selectedDate).format('YYYYMMDD'),
            sortBy: '',
            searchType: 'DAILY',
            centralRoomTypeCode: query.centralRoomTypeCode,
            viewCode: query.viewCode,
            ownerBenefitLevel: sessionStorage.read(ReservationService.BENEFIT_LEVEL)
        };
        const sessionId = this.getSessionIdForRequest();

        return timeoutPromise(to, "loading daily range availability search results",
            axios.post(apiUrl, req,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': sessionId,
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`daily range availability search - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<Results>;
    }

    getHeldResortsFake(): Promise<ResortResult[]> {
        return new Promise<ResortResult[]>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(heldResortResults);
                let sr: ResortResult[] = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getFakeWaitListInformation() {
        return new Promise<WaitlistAYPResult>((resolve, reject) => {
            setTimeout(() => {
                let wlStr = JSON.stringify(createWaitlistResponse);
                let wl: WaitlistAYPResult = JSON.parse(wlStr);
                resolve(wl);
            }, 1500);
        })
    }

    getAYPWaitlistInformation(waitlistId: number): Promise<WaitlistAYPResult> {
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.getFakeWaitListInformation();
        }

        return new Promise<WaitlistAYPResult>((resolve, reject) => {
            setTimeout(() => {
                let waitlistResultStr: string =  sessionStorage.read("WAITLIST_RESPONSE");
                let waitlistResult: WaitlistAYPResult = JSON.parse(waitlistResultStr);
                if(!waitlistResult) {
                    reject("NOT ABLE GET waitlist result from session storage");
                }
                resolve(waitlistResult);
            }, 1500);
        });
    }

    /**
     * This is a shell for a future API call, this method takes in a waitlist ID and returns information related to waitlist ID
     * @returns 
     */
    getWaitListInformation(waitlistId: number): Promise<any> {
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.getFakeWaitListInformation();
        }
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiResUrl: string = WAITLIST_API_URL + `/${waitlistId}`;

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for waitlist summary",
            axios.get(apiResUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
            .then((resp: AxiosResponse<WaitlistAYPResult>) => {
                    log.debug(`waitlist summary - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiResUrl)));
    }

    //TODO: change name of service method
    async createWaitlist(params: WaitlistData): Promise<any> {
        const {
            // ownerId,
            totalPointsToHold,
            checkInRangeStart,
            checkInRangeEnd,
            propertyCode,
            numberOfGuests,
            numberOfNights,
            accessibility,
            maxPpe,
            checkInSunday,
            checkInMonday,
            checkInTuesday,
            checkInWednesday,
            checkInThursday,
            checkInFriday,
            checkInSaturday,
            sessionId,
            // expirationLeadTime,
            priority,
            waitlistRooms,
            contracts,
        } = params;

        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        let apiUrl: string = WAITLISTS_AYP_URL;

        let req: CreateWaitlistRequest = {
            // ownerId,
            totalPointsToHold,
            checkInRangeStart,
            checkInRangeEnd,
            propertyCode,
            numberOfGuests,
            numberOfNights,
            accessibility,
            maxPpe,
            checkInSunday,
            checkInMonday,
            checkInTuesday,
            checkInWednesday,
            checkInThursday,
            checkInFriday,
            checkInSaturday,
            sessionId,
            // expirationLeadTime,
            priority,
            waitlistRooms,
            contracts,
        };

        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            const holds = await this.getHeldResortsFake();
            return {
                ReservedInventoryIds: [holds[0].ReservedInventoryID],
            };
        }

        return timeoutPromise(to, "create a waitlist room ",
            axios.post(apiUrl, req,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<any>) => {
                        log.debug(`reservation hold attempt - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl)));
    }
    /**
     * attempt to place a new hold, or confirm an existing hold.
     * to confirm an existing hold, pass ReservedInventoryID in params
     */
    placeHold(params: HoldRequestData): Promise<any> {
        const {
          resortCode,
          checkIn,
          marshaRateCode,
          numOfGuests,
          numOfNights,
          accessibility,
          hearingaccessible,
          ReservedInventoryID,
          roomPoolCode,
          dailyresults,
          contracts
        } = params;

        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        let apiUrl: string = RESERVATION_API_URL;

        // if supplied with a ReservedInventoryID, it means we are attempting
        // to confirm a hold
        if (ReservedInventoryID !== undefined) {
          apiUrl += `/${ReservedInventoryID}`;
        }

        let req: PlaceHoldRequest = {
          resortCode,
          checkIn,
          marshaRateCode,
          numOfGuests,
          numOfNights,
          accessibility,
          hearingaccessible,
          roomPoolCode,
          dailyresults,
          contracts
        };


        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getHeldResortsFake().then(holds => {
                return {
                    ReservedInventoryIds: [holds[0].ReservedInventoryID],
                };
            });
        }

        return timeoutPromise(to, "placing a hold on a room",
            axios.post(apiUrl, req,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<any>) => {
                        log.debug(`reservation hold attempt - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl)));
    }

    getHeldResorts(): Promise<ResortResult[]> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        // Prevent API call if cognitoSsoToken is not available
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiResUrl: string = RESERVATION_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.getHeldResortsFake();
        }
        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for held resorts",
            axios.get(apiResUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<ResortResult[]>) => {
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiResUrl))) as Promise<ResortResult[]>;
    }

    deleteHeldResortsFake(ReservedInventoryID: number | null = null) {
        return new Promise<ResortResult[]>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(heldResortResults);
                let sr: ResortResult[] = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    deleteHeldResorts(ReservedInventoryID: number | null = null): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        const apiResUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/owner/hold${ReservedInventoryID ? ('/' + ReservedInventoryID)  : ''}`;
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        console.log({deleting_held_resort: ReservedInventoryID})

        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            this.deleteHeldResortsFake();
        }

        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "deleting held resorts",
            axios.delete(apiResUrl,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`delete held resorts - response body: ${JSON.stringify(resp)}`);
                        return resp.data;
                    }
                )
                .catch((error: any) => handleError(error, apiResUrl)));
    }
  // resortCode: string, selectedDate: string, query: FormData

    autoAdjustUsage(autoAdjustPayload: any, ReservedInventoryID: number | null = null): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        const apiResUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/owner/autoAdjustUsage${ReservedInventoryID ? ('/' + ReservedInventoryID)  : ''}`;
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "auto adjust",
            axios.post(apiResUrl, autoAdjustPayload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`auto adjust - response body: ${JSON.stringify(resp)}`);
                        return resp.data;
                    }
                )
                .catch((error: any) => handleError(error, apiResUrl)));
    }

    searchRoomInfo(roomParams: any): Promise<Results> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl = JAHIA_ROOMS_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.searchFakeDailyAvailability();
        }

        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        let  SearchRoomInfoRequest: any = {

              ...roomParams

        };

        return timeoutPromise(to, "loading room info search results",
            axios.post(apiUrl, SearchRoomInfoRequest,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-correlation-id': generateCorrelationId(),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<Results>) => {
                        log.debug(`room  info search - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<Results>;
    }

    getResBookingSummaryFake(): Promise<any> {
        return new Promise<ResortResult[]>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(resSummary);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getResBookingSummary(resId:number, borrowedPoints: boolean): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiResUrl: string = RESERVATION_BOOK_API_URL + `/${resId}` + `?borrowedPoints=${borrowedPoints}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getResBookingSummaryFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for reservation summary",
            axios.get(apiResUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<any>) => {
                        log.debug(`reservation summary - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiResUrl)));
    }

    bookReservationFake(): Promise<BookResortResult> {
        return new Promise<any>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(bookingResult);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getResWaitlistSummaryFake(): Promise<any> {
        return new Promise<ResortResult[]>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(resWaitlistSummary);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getResWaitlistSummary(waitListId:number): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiResUrl: string = WAITLIST_API_URL + `/${waitListId}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.getResWaitlistSummaryFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for reservation summary",
            axios.get(apiResUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<any>) => {
                        log.debug(`reservation summary - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiResUrl)));
    }

    getWaitlistSummaryReviewFake(): Promise<WaitlistSummaryResponse> {
        return new Promise<WaitlistSummaryResponse>((resolve, reject) => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(resWaitlistSummary);
                let sr: WaitlistSummaryResponse = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    //TODO: This is randomly erroring out, had to switch between WaitlistSummaryResponse and any in the promise, find out why ?
    getWaitlistSummaryReview(waitlistResult: WaitlistAYPResult): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiResUrl: string = WAITLIST_SUMMARY_REVIEW_URL + `/${waitlistResult.waitlistReservationID}` + '?borrowedPoints=false';
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.getWaitlistSummaryReviewFake();
        }


        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        //TODO: Remove ineligible usages array from the request
        return timeoutPromise(to, "loading data for reservation summary",
            axios.post(apiResUrl, waitlistResult, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<WaitlistSummaryResponse>) => {
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiResUrl)));
    }

    bookReservation(params: BookResortParams, resId: number): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiResUrl: string = RESERVATION_BOOK_API_URL + `/${resId}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.bookReservationFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for reservation booking",
            axios.post(apiResUrl, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<any>) => {
                        log.debug(`reservation booking - response body: ${JSON.stringify(resp)}`);
                        return resp
                    }
                )
                .catch((error: any) => handleError(error, apiResUrl))) as Promise<any>;
    }

    getResortOverviewFake(): Promise<any> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(getResortOverviewResult);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getResortOverview(propertyCode: string): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = `https://prod-owner-search-vo.mvwc.com/api/exp/owner-search/v2/voa/properties/${propertyCode}/overview`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getResortOverviewFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for resort overview",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
            .then((resp: AxiosResponse<any>) => {
                    log.debug(`resort overview - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<any>;
    }

    getAdsFake(): Promise<GetAdsResponse> {
        return new Promise<GetAdsResponse>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify({});
                let sr: GetAdsResponse = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getAds(): Promise<GetAdsResponse> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/ads`;
        // const apiUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/ads/${propertyCode}/overview`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getAdsFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for resort overview",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
            .then((resp: AxiosResponse<GetAdsResponse>) => {
                    log.debug(`ads - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<GetAdsResponse>;
    }

    //5762307
    getReservation(resId: number,resType:string): Promise<ReservationResult> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/owner/reservation/${resId}?resType=${resType}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getReservationFake();
        }

        // return this.getReservationFake();

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for resort overview",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
            .then((resp: AxiosResponse<any>) => {
                    log.debug(`resort overview - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<any>;
    }

    //MVC-902
    getReservationWeeks({ confirmationNumber, inventoryId }: { confirmationNumber: number; inventoryId: string }): Promise<ReservationResult> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        const apiUrl: string = `https://prod-owner-profile-vo.mvwc.com/api/exp/owner-profile/v2/voa/owner/weeks/guestProfile/${confirmationNumber}?inventoryId=${inventoryId}`;
        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        return timeoutPromise(to, "loading data for resort overview",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': Guid.create().toString().replace('-', ''),
                    'Authorization': cognitoSsoToken ? `Bearer ${cognitoSsoToken}` : '',
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
            .then((resp: AxiosResponse<any>) => {
                    log.debug(`resort overview - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<any>;
    }

    getReservationFake(): Promise<ReservationResult> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(reservationResult);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getReservationsFake(reservationType: ReservationType): Promise<GetReservationActivity> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(getReservationsResult);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getReservations(reservationType: ReservationType): Promise<GetReservationActivity> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = RESERVATION_LIST_API_URL + `?reservationType=${reservationType}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getReservationsFake(reservationType);
        }

        
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for reservation list",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<GetReservationActivity>) => {
                        log.debug(`reservation list - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<GetReservationActivity>;
    }

    getCountriesFake(): Promise<GetCountriesResult[]> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(getCountriesJSON);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getCountries(): Promise<GetCountriesResult[]> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = COUNTRY_LIST_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getCountriesFake();
        }

        
        //needed?
        //const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);

        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        // return this.getCountriesFake();

        return timeoutPromise(to, "loading data for countries list",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<GetCountriesResult[]>) => {
                        log.debug(`countries list - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<GetCountriesResult[]>;
    }

    getTransactionsFake(): Promise<TransactionHistoryResult> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(getTransactionsResult);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }
    
    getTransactions(): Promise<TransactionHistoryResult> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = TRANSACTION_LIST_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getTransactionsFake();
        }
    
        
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
    
        return timeoutPromise(to, "loading data for transaction list",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<TransactionHistoryResult>) => {
                        log.debug(`transaction list - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<TransactionHistoryResult>;
    }

    getOwnerInfoFake(): Promise<OwnerInfoRecord> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = "{\n" +
                    "    \"cieId\": 3965193124,\n" +
                    "    \"email\": \"testowner@vacationclub.com\",\n" +
                    "    \"ownerNumber\": \"7989\",\n" +
                    "    \"firstName\": \"Yun Seok\",\n" +
                    "    \"middleName\": \"\",\n" +
                    "    \"lastName\": \"Gwak\",\n" +
                    "    \"sourceSystem\": \"TSW\",\n" +
                    "    \"ownerBenefitLevels\": [\n" +
                    "        {\n" +
                    "            \"level\": \"Owner/Member\",\n" +
                    "            \"points\": 2200,\n" +
                    "            \"code\": \"OWNER\"\n" +
                    "        }\n" +
                    "    ],\n" +
                    "    \"memberships\": [\n" +
                    "        {\n" +
                    "            \"membershipType\": \"MRW\",\n" +
                    "            \"membershipId\": \"415202928\"\n" +
                    "        }\n" +
                    "    ]\n" +
                    "}";
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    // getHopperAvailabiltyInfoFake(): Promise<HopperAvailabiltyInfo> {
    //     return new Promise<any>(resolve => {
    //         setTimeout(() => {
    //             let srStr: string = "{\n" +
    //                 "    \"OwnerID\": \"200078, \n" +
    //                 "    \"ClubCode\": \"VSE, \n" + 
    //                 "    \"PointsBalance\": \"10000, \n" +
    //                 "    \"OwnerStatus\": \"GOOD, \n"  +
    //                 "    \"OwnerAlert\": \",\n" +
    //                 "     \"EligibleUsage\": \"[], \n"
    //                 "}";
    //             let sr: any = JSON.parse(srStr);
    //             resolve(sr);
    //         }, 1500);
    //     });
    // }

    getOwnerInfo(): Promise<OwnerInfoRecord> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = OWNER_INFO_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getOwnerInfoFake();
        }


        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        // return this.getOwnerInfoFake();

        return timeoutPromise(to, "loading owner info data",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<OwnerInfoRecord>) => {
                        log.debug(`owner info - response body: ${JSON.stringify(resp)}`);
                        if(resp.data.ownerBenefitLevels && resp.data.ownerBenefitLevels.length > 0){
                            sessionStorage.write(ReservationService.BENEFIT_LEVEL,resp.data.ownerBenefitLevels[0].level);
                        } else {
                            sessionStorage.write(ReservationService.BENEFIT_LEVEL,'');
                        }
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<OwnerInfoRecord>;
    }

    getHopperAvailability(spendDate: any, clubCode: any, provider: any, ownerId: any): Promise<HopperAvailabiltyInfo> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = HOPPER_AVAIL_INFO_API_URL + `?spendDate=${spendDate}&` + `clubCode=${clubCode}&` + `provider=${provider}&` + `ownerID=${ownerId}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        // if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
        //     return this.getHopperAvailabiltyInfoFake();
        // }


        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        // return this.getOwnerInfoFake();

        return timeoutPromise(to, "loading owner info data",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE),
                    'X-API-Client': 'ownerportal'
                }
            })
                .then((resp: AxiosResponse<HopperAvailabiltyInfo>) => {
                        log.debug(`owner info - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<HopperAvailabiltyInfo>;
    }
    
    getTermsForArrivingGuestInfoFake(): Promise<GuestTerms[]> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(getGuestTerms);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getTransferContractsFake(): Promise<any> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(getTransferContracts);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getCancelReservationDetailsFake(): Promise<any> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(cancelReservationDetailRequest);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    getTermsForArrivingGuestInfo(): Promise<GuestTerms[]> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);

        const apiUrl: string = GUEST_TERMS_API_URL;

        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getTermsForArrivingGuestInfoFake();
        }


        // return this.getTermsForArrivingGuestInfoFake();

        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "getting terms for arriving guest info",
            axios.get(GUEST_TERMS_API_URL, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': Guid.create().toString().replace('-', ''),
                    'Authorization': cognitoSsoToken ? `Bearer ${cognitoSsoToken}` : '',
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<any>) => {
                        log.debug(`arriving guest info - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<any>;
    }

    submitGuestProfile(guestInfoRequest: GuestProfileRequest, resId:any): Promise<GuestProfileResponse> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);

        const apiURL: string = RESERVATION_DETAIL_API_URL+`/${resId}/guests`;

        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        guestInfoRequest.ownerId = sessionStorage.read(OWNER_NUMBER);
        return timeoutPromise(to, "loading search results",
            axios.put(apiURL, guestInfoRequest,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-correlation-id': Guid.create().toString().replace('-', ''),
                        'Authorization': cognitoSsoToken ? `Bearer ${cognitoSsoToken}` : '',
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<GuestProfileResponse>) => {
                        log.debug(`response body ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiURL))) as Promise<GuestProfileResponse>;
        
    }
    
    getTransferPointsContracts(): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = TRANSFER_POINTS_CONTRACTS_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getTransferContractsFake();
        }


        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        // return this.getTransferContractsFake();

        return timeoutPromise(to, "loading owner info data",
            axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': Guid.create().toString().replace('-', ''),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
                .then((resp: AxiosResponse<any>) => {
                        log.debug(`transfer points contracts - response body: ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<OwnerInfoRecord>;
    }
    

    submitTransferPointsFake(): Promise<any> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(submitTrasnferPoints);
                let sr: any = JSON.parse(srStr);
                resolve(sr);
            }, 1500);
        });
    }

    submitTransferPoints(transferPointsRequest: TransferPointRequest): Promise<TransferPointResponse> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiURL: string = TRANSFER_POINTS_CONTRACTS_URL;
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        return timeoutPromise(to, "loading search results",
            axios.post(apiURL, transferPointsRequest,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-correlation-id': Guid.create().toString().replace('-', ''),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                        'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                    },
                })
                .then((resp: AxiosResponse<TransferPointResponse>) => {
                        log.debug(`response body ${JSON.stringify(resp)}`);
                        return resp.data
                    }
                )
                .catch((error: any) => handleError(error, apiURL))) as Promise<TransferPointResponse>;
    }

    getCancelReservationDetails(resId: number,resType:string, payload: any): Promise<ReservationResult> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/owner/reservation/${resId}/cancelpreview?resType=${resType}`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getCancelReservationDetailsFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for cancel resort overview",
            axios.post(apiUrl, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE)
                }
            })
            .then((resp: AxiosResponse<any>) => {
                    log.debug(`resort overview - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<any>;
    }

    gettermsCondition(): Promise<TermConditionRecord[]> {
        console.log("gettermsCondition: Fetching terms and conditions.");
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            console.warn("gettermsCondition: No Cognito SSO token found. Aborting.");
            return Promise.reject({ code: 401});
        }
        
        const apiUrl: string = TERMS_CONDITION_URL;
        console.log(`gettermsCondition: API URL is ${apiUrl}`);
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;
        
        return timeoutPromise(
          to,
          "loading terms condition data",
          axios
            .get<{ termsConditions: TermConditionRecord[] }>(apiUrl, { // This seems to be a syntax error from previous changes. Correcting it.
              headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${cognitoSsoToken}`,
            },
            })
            .then((response) => {
                console.log("gettermsCondition: Successfully fetched data.", response.data);
                return response.data.termsConditions;
            }) // Return the array from the response
            .catch((error: any) => {
                console.error("gettermsCondition: Error fetching terms and conditions.", error);
                return handleError(error, apiUrl);
            })
        );
    }

    postCancelReservationDetails(resId: number,resType:string, payloadData: any): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = `https://prod-owner-reservation-vo.mvwc.com/api/exp/owner-reservation/v2/voa/owner/reservation/${resId}/cancel`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.getCancelReservationDetailsFake();
        }

        const savedSID = sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for cancel resort overview",
            axios.post(apiUrl, payloadData, {
                headers: {
                    'Content-Type': 'application/json',
                    'sessionId': savedSID ? savedSID : Guid.create().toString(),
                    'X-correlation-id': generateCorrelationId(),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id' : sessionStorage.read(OWNER_NUMBER),
                    'X-Integration-Source-Name' : sessionStorage.read(SYSTEM_INTEGRATION_MODE),
                    'X-WebSite-Lang': sessionStorage.read('Selected-Lang')
                }
            })
            .then((resp: AxiosResponse<any>) => {
                    log.debug(`resort overview - response body: ${JSON.stringify(resp)}`);
                    return resp.data
                }
            )
            .catch((error: any) => handleError(error, apiUrl))) as Promise<any>;
    }
}



function generateCorrelationId() : string {
    const initMode: string = sessionStorage.read(SYSTEM_INTEGRATION_MODE);
    if(initMode && initMode === "VOA") {
        const correlationId: string = sessionStorage.read(X_CORRELATION_ID);
        return `${Guid.create().toString().replace('-', '')} - ${correlationId}`;
    }
    return Guid.create().toString().replace('-', '');
}



export default ReservationService;
